export const getAdminHomeReducer = state => state.adminHomeReducer
